import { render, staticRenderFns } from "./BreaksForm.vue?vue&type=template&id=2497c44e&scoped=true"
import script from "./BreaksForm.vue?vue&type=script&lang=js"
export * from "./BreaksForm.vue?vue&type=script&lang=js"
import style0 from "./BreaksForm.vue?vue&type=style&index=0&id=2497c44e&prod&scoped=true&lang=css"
import style1 from "./BreaksForm.vue?vue&type=style&index=1&id=2497c44e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2497c44e",
  null
  
)

export default component.exports